import React, { useState, useContext } from 'react';
import { SidebarContext } from '../../context/SidebarContext.js';
import { authContext } from '../../context/AuthContext.js';
import MenuOpenOutlinedIcon from '@mui/icons-material/MenuOpenOutlined';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Drawer from '@mui/material/Drawer';
import CloseIcon from '@mui/icons-material/Close';
import AccountDropdown from '../../components/Account/AccountDropdown';
import AppConnection from '../Account/AuthAccounts/AppConnections.jsx';
import Bread_Bskt from '../../images/Bread_Bskt.png';
import { useNavigate } from 'react-router-dom';

export default function NonMobileHeader({ usrName }) {
    const { toggleSidebar, isOpen } = useContext(SidebarContext);
    const { logout, userRole } = useContext(authContext);
    const navigate = useNavigate();

    const [accntBttn, setAccntBttn] = useState(false);
    const [logoTarget, setLogoTarget] = useState(null);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [openAuthAccounts, setOpenAuthAccounts] = useState(false);

    const handleClose = async (selection) => {
        setAccntBttn(false);
        setLogoTarget(null);

        switch (selection) {
            case 'logout': {
                const success = await logout();
                if (success) return logout(true);
                return setOpenSnackbar(true);
            }
            case 'accounts':
                setOpenAuthAccounts(true);
                break;
            case 'settings':
                if (isOpen) toggleSidebar();
                navigate('/account-settings/user-profile');
                break;
            default:
                break;
        }
    };

    const handleAcctDrop = (event) => {
        if (accntBttn) {
            setAccntBttn(false);
            setLogoTarget(null);
            return;
        }
        setLogoTarget(event.currentTarget);
        setAccntBttn(true);
    };

    const goHome = () => {
        if (!isOpen) toggleSidebar();
        navigate('/');
    };

    return (
        <header className="app-header">
            <div className="app-header-left">
                <IconButton
                    className="app-header-menu"
                    onClick={toggleSidebar}
                    aria-label={isOpen ? 'Collapse sidebar' : 'Expand sidebar'}
                    size="small"
                >
                    {isOpen ? (
                        <MenuOpenOutlinedIcon sx={{ fontSize: 22 }} />
                    ) : (
                        <MenuOutlinedIcon sx={{ fontSize: 22 }} />
                    )}
                </IconButton>

                <button type="button" className="app-brand" onClick={goHome}>
                    <img src={Bread_Bskt} alt="" className="app-brand-mark" />
                    <span className="app-brand-name">Bread Bskt</span>
                </button>
            </div>

            <div className="app-header-right">
                <IconButton
                    id="account-menu-button"
                    className="app-header-avatar-btn"
                    onClick={handleAcctDrop}
                    aria-label="Account menu"
                    aria-controls={accntBttn ? 'account-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={accntBttn ? 'true' : undefined}
                    size="small"
                >
                    <Avatar className="app-header-avatar">
                        {(usrName?.[0] || '?').toUpperCase()}
                    </Avatar>
                </IconButton>
            </div>

            <AccountDropdown
                target={accntBttn ? logoTarget : null}
                close={handleClose}
                role={userRole}
            />

            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={openSnackbar}
                autoHideDuration={6000}
                onClose={() => setOpenSnackbar(false)}
            >
                <Alert onClose={() => setOpenSnackbar(false)} severity="error">
                    Unable to log out!
                </Alert>
            </Snackbar>

            <Drawer
                anchor="left"
                sx={{
                    '& .MuiDrawer-paper': {
                        height: '100%',
                        width: 'min(60%, 480px)',
                        borderRadius: 0,
                        overflow: 'hidden',
                    },
                }}
                open={openAuthAccounts}
                onClose={() => setOpenAuthAccounts(false)}
            >
                <div className="app-header-drawer">
                    <IconButton
                        onClick={() => setOpenAuthAccounts(false)}
                        aria-label="Close"
                        sx={{
                            position: 'absolute',
                            top: 12,
                            right: 12,
                            backgroundColor: '#fff',
                            boxShadow: '0 1px 4px rgba(0,0,0,0.12)',
                            '&:hover': { backgroundColor: '#F1F5F9' },
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <AppConnection />
                </div>
            </Drawer>
        </header>
    );
}
